export default __webpack_public_path__ + "static/media/fc_icon_bad.92aed6ee.svg";